"use client"

import { useEffect, useRef } from "react"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"

const faqs = [
  {
    question: "What types of reports do you design?",
    answer:
      "We specialize in designing Annual Reports, Integrated Reports, Sustainability Reports, and CSR Reports for companies across various industries.",
  },
  {
    question: "How long does the report design process take?",
    answer:
      "The timeline varies depending on the complexity and scope of the project. Typically, a complete annual report design process takes 4-6 weeks from concept to final delivery.",
  },
  {
    question: "Do you provide content writing services for reports?",
    answer:
      "Yes, our team includes content specialists who can help craft compelling narratives for your reports, transforming complex information into engaging stories that resonate with your stakeholders.",
  },
  {
    question: "Can you handle both print and digital report formats?",
    answer:
      "We provide comprehensive solutions for both printed reports and interactive digital versions, ensuring consistency across all formats while optimizing each for its specific medium.",
  },
  {
    question: "How do you ensure the report aligns with our brand identity?",
    answer:
      "We begin each project with a thorough review of your brand guidelines and work closely with your team to ensure the report design reflects your company's visual identity while enhancing the presentation of your content.",
  },
]

export default function FaqSection() {
  const sectionRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current || !contentRef.current) return

      const sectionTop = sectionRef.current.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      // Check if section is in view
      if (sectionTop < windowHeight * 0.75) {
        contentRef.current.classList.add("active")
      } else {
        contentRef.current.classList.remove("active")
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <section ref={sectionRef} className="md:py-20 py-16 bg-white" id="wisdom">
      <div className="container mx-auto px-4 max-w-4xl">
        <div ref={contentRef} className="scroll-reveal">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center">Frequently Asked Questions</h2>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-xl text-left font-medium text-gray-800 py-4">{faq.question}</AccordionTrigger>
                <AccordionContent className="text-lg text-gray-600">{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  )
}
